import APIMapper from './APIMapper';
import WidgetController from "../../controllers/WidgetController";

class WidgetAPIMapper extends APIMapper {
  update(change) {
    const { item, onSuccess, onError } = change;

    return WidgetController.putWidget(item.nextValue)
      .then(onSuccess)
      .catch(onError);
  }

  delete(change) {
    const { item, onSuccess, onError } = change;

    return WidgetController.deleteWidget(item.prevValue.id)
      .then(onSuccess)
      .catch(onError);
  }
}

export default new WidgetAPIMapper();
